import { useEffect, useState } from 'react';
import { Button, Panel, Stack, Typography } from '@src/components';
import { Shell } from '@src/components/Shell/Shell';
import { PageContent } from '@src/components/PageContent/PageContent';

export function PremiumLocalCheckoutPage() {
  const [details, setDetails] = useState<{ amount: string; site: string; receiptEmail: string } | null>(null);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const [token] = useState(() => window.location.hash.slice(1));
  useEffect(() => {
    let active = true;
    void fetch('/api/premium/payment/local/details', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ token }) })
      .then(async response => { if (!response.ok) throw new Error('Local checkout is unavailable or expired.'); return response.json(); })
      .then(value => { if (active) setDetails(value); })
      .catch(reason => { if (active) setError(reason.message); });
    return () => { active = false; };
  }, [token]);
  async function complete(outcome: 'success' | 'failed') {
    setBusy(true);
    setError('');
    try {
      const response = await fetch('/api/premium/payment/local/complete', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ token, outcome }) });
      if (!response.ok) throw new Error('Could not complete the local checkout.');
      const result = await response.json();
      window.location.assign(result.returnUrl);
    } catch (reason) { setError((reason as Error).message); setBusy(false); }
  }
  return <Shell><PageContent><Panel padding="large"><Stack gap={5}>
    <Typography as="h1" role="title/page">Local test checkout</Typography>
    <Typography as="p" role="body/base">No money is charged. Success activates Premium for this local profile and its games.</Typography>
    {details && <><Typography as="p" role="body/base">{details.amount} {details.site === 'com' ? 'USD' : 'RUB'} · {details.receiptEmail}</Typography>
      <Button testId="local-checkout-success" disabled={busy} onClick={() => void complete('success')}>Simulate successful payment</Button>
      <Button testId="local-checkout-failed" variant="secondary" disabled={busy} onClick={() => void complete('failed')}>Simulate failed payment</Button></>}
    {error && <p role="alert">{error}</p>}
  </Stack></Panel></PageContent></Shell>;
}
